import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchGeminiAnalysis = createAsyncThunk(
  "gemini/fetchAnalysis",
  async ({ lighthouseResults, bundleAnalysis }, { rejectWithValue }) => {
    try {
      // Only send necessary data
      const optimizedLighthouseData = {
        url: lighthouseResults.url,
        performanceScore: lighthouseResults.performanceScore,
        webVitals: lighthouseResults.webVitals,
        // Exclude raw lighthouse data which can be very large
        timestamp: lighthouseResults.timestamp,
      };

      const optimizedBundleData = bundleAnalysis
        ? {
            totalSize: bundleAnalysis.totalSize,
            estimatedGzipSize: bundleAnalysis.estimatedGzipSize,
            frameworks: bundleAnalysis.frameworks,
            recommendations: bundleAnalysis.recommendations,
          }
        : null;

      console.log("🚀 Sending analysis request to server");
      const response = await fetch("/api/analyze", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          lighthouseResults: optimizedLighthouseData,
          bundleAnalysis: optimizedBundleData,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error("❌ Server returned error:", errorData);
        return rejectWithValue(
          errorData.error || `Server error: ${response.status}`
        );
      }

      const data = await response.json();

      if (!data.success) {
        console.error("❌ Analysis failed:", data);
        return rejectWithValue(data.error || "Analysis failed");
      }

      console.log("✅ Successfully received recommendations");
      return data.recommendations;
    } catch (error) {
      console.error("❌ Failed to fetch Gemini analysis:", {
        message: error.message,
        stack: error.stack,
        name: error.name,
      });
      return rejectWithValue(error.message);
    }
  }
);

const geminiSlice = createSlice({
  name: "gemini",
  initialState: {
    recommendations: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearRecommendations: (state) => {
      state.recommendations = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeminiAnalysis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGeminiAnalysis.fulfilled, (state, action) => {
        state.loading = false;
        state.recommendations = action.payload;
      })
      .addCase(fetchGeminiAnalysis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearRecommendations } = geminiSlice.actions;
export default geminiSlice.reducer;
